export enum ErrorCode {
  INCORRECT_DATA = '400', // Получены некорректные данные
  USER_NOT_CONFIRMED = '401', // Участник опроса не подтвержден
  SURVEY_ALREADY_COMPLETED = '430', // Участник уже проходил этот опрос
  USER_EXCLUDED_BY_POLICY = '431', // Участник исключен по политике коммуникаций
  SURVEY_NOT_FOUND = '434', // Анкета не найдена
  USER_NOT_FOUND = '436', // Участник опроса не найден
  TECHNICAL_ERROR = '530', // Не удалось обработать запрос (техническая проблема)
  EPK_CM_PAIR = '440', // Epk_id не соответствует участнику опроса (cm_id).
  OTHER = '-1' // Другая ошибка
}
